define('taoQtiItem/qtiXmlRenderer/renderers/choices/SimpleAssociableChoice',['tpl!taoQtiItem/qtiXmlRenderer/tpl/element'], function(tpl){
    return {
        qtiClass : 'simpleAssociableChoice',
        template : tpl
    };
});
